import * as React from 'react';
import glamorous from 'glamorous';
import { position } from 'polished';
import FixToViewport from 'app/components/commons/FixToViewport';
import NotificationsBoard from 'app/components/notifications/NotificationsBoard';

const NotificationsDisplayWrapper = glamorous.div(({ theme }) => ({
  backgroundColor: theme.color.basis1,
  [theme.mediaQuery.tabletLandscapeAndUp]: {
    backgroundColor: 'transparent',
    ...position('absolute', 8, 10, null, null),
    width: 400,
  },
}));

function NotificationsDisplay() {
  return (
    <FixToViewport placement="top" type="notification">
      <NotificationsDisplayWrapper>
        <NotificationsBoard />
      </NotificationsDisplayWrapper>
    </FixToViewport>
  );
}

export default NotificationsDisplay;
